import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import { Card, createStyles, Divider, Grid, Group, Skeleton, Text, Title, } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";
import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import Container from "../Layout/Container/Container";

const useStyles = createStyles(() => ({
  imageWrapper: {
    width: "100%",
    height:"75px",
    aspectRatio: "1/0.5",
    position: "relative", /* backgroundColor:"pink" */
  },
}));

function NewCardNew({ item, isLoading = false }) {
  const { classes } = useStyles();
  const { locale } = useRouter();

  return (
    <motion.div
      whileHover={{ scale: 1.02 }} 
    >
    <Container shadow="sm"/*  bg="pink" */ p={0} radius="md" sx={{ height: "100%" }}>
      <Link scroll={false} href={`/tin-tuc/${item?.slug}` || "#"}>
        <a>
          <Skeleton visible={isLoading}>
            <Grid align="flex-start" >
                <Grid.Col span={4} /* bg="green" */>
                    <div className={classes.imageWrapper}>
                        {!isLoading && (
                        <Image
                            src={appendImageUrlFromAPI({src: item?.picture, size:"s"})}
                            alt="Norway"
                            layout="fill"
                            objectFit="contain"
                        />
                        )}
                    </div>
                </Grid.Col>
                <Grid.Col span={8} /* bg="gray" */>
                    <div>
                    <Title order={1}
                        style={{ letterSpacing: 1 }}
                        transform="capitalize"
                        size="xs"
                        lineClamp={2}
                        weight="600"
                    >
                        {item?.title ||
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."}
                    </Title>

                    <Divider size="xs" /* my="sm" */ style={{
                        background:"black"
                    }}/>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconCalendar size={15} />
                        <Text size="xs" ml={8}>
                            {new Date(item?.date_updated).toLocaleDateString(locale, {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            })}
                        </Text>
                    </div>
                    </div>
                </Grid.Col>
              </Grid>
          </Skeleton>
        </a>
      </Link>
    </Container>
    </motion.div>
  );
}

export default NewCardNew;
